import { render } from "./ResendOTPCode.vue?vue&type=template&id=3503c637&scoped=true"
import script from "./ResendOTPCode.vue?vue&type=script&lang=js"
export * from "./ResendOTPCode.vue?vue&type=script&lang=js"

import "./ResendOTPCode.vue?vue&type=style&index=0&id=3503c637&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3503c637"]])

export default __exports__